import { useMemo } from "react";
import { Link } from "@tanstack/react-router";
import type { PaidStudent } from "@/lib/admin-students.functions";
import { COHORTS, classifyCohort, type Cohort } from "@/lib/intake-cohort";

export function IntakeCohortPanel({ students }: { students: PaidStudent[] }) {
  const grouped = useMemo(() => {
    const g: Record<Cohort, PaidStudent[]> = { fall_2026: [], spring_2027: [], fall_2027: [] };
    for (const s of students) {
      const c = classifyCohort(s);
      if (c) g[c].push(s);
    }
    return g;
  }, [students]);

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="h-full rounded-2xl border border-border bg-card p-5 shadow-sm">
      <h2 className="text-xs font-black uppercase tracking-wider text-foreground">Intakes</h2>
      <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
        {COHORTS.map((c) => {
          const arr = grouped[c.key];
          const approved = arr.filter((s) => s.interview_status === "approved").length;
          const refused = arr.filter((s) => s.interview_status === "refused").length;
          const upcoming = arr.filter((s) => s.interview_date && s.interview_date >= today).length;
          return (
            <Link
              key={c.key}
              to={`/admin/cohorts/${c.slug}` as "/admin/cohorts/fall-2026"}
              className="rounded-xl border border-border p-4 text-left transition hover:border-primary hover:bg-primary/5"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-bold text-foreground">{c.label}</span>
                <span className="text-2xl font-black tabular-nums text-foreground">{arr.length}</span>
              </div>
              <p className="text-[11px] text-muted-foreground">{c.window}</p>
              <p className="mt-2 text-xs font-semibold text-muted-foreground">
                {approved} approved · {refused} refused · {upcoming} upcoming
              </p>
              <span className="mt-2 inline-block text-xs font-bold text-primary">Open page →</span>
            </Link>
          );
        })}
      </div>

    </div>
  );
}
